<template>
	<svg xmlns="http://www.w3.org/2000/svg" width="26" height="26" viewBox="0 0 26 26">
		<g id="Ellipse_759" data-name="Ellipse 759" fill="none" stroke="#30aeed" stroke-width="1">
			<circle cx="13" cy="13" r="13" stroke="none" />
			<circle cx="13" cy="13" r="12.5" fill="none" />
		</g>
		<path
			id="Polygon_46"
			data-name="Polygon 46"
			d="M5.168,1.248a1,1,0,0,1,1.664,0l4.131,6.2A1,1,0,0,1,10.131,9H1.869a1,1,0,0,1-.832-1.555Z"
			transform="translate(19 7) rotate(90)"
			fill="#28adf1"
		/>
	</svg>
</template>

<script>
export default {
	name: 'PlayRecordingSvg',
};
</script>
